import React, {useContext, useState} from 'react';
import {Button, Descriptions, Form, FormInstance, Input, Space, Tabs} from 'antd';
import {observer} from "mobx-react";
import {useLoaderData, useNavigate} from "react-router-dom";
import {Translate} from "../../../components/util/translation.util";
import {CardStyled} from "../../../components/styled/card.styled";
import {ButtonBar} from "../../../builder";
import {TranslationDomainEnum} from "../../../types/enums";
import {MaxLengthConstraint, RequiredConstraint} from "../../../builder/form/validation/constraints";
import {Prompt} from "../../../components/promptBlocker/promptBlocker";
import {StoreContext} from "../../../store.context";

const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
    style: { padding: '16px' }
};

export const EntityTranslateForm: React.FC<{
    onSubmit?: (values: any) => void
}> = observer((props) => {
    const { appStore: { translate }} = useContext(StoreContext);
    const data = useLoaderData() as any;
    const formRef = React.createRef<FormInstance>();
    const navigate = useNavigate();
    const [ formStateDirty, setFormStateDirty] = useState<boolean>(false);

    const onFinish = (values: any) => {
        const data = Object.keys(values).map(translation => {
            return values[translation];
        })[0];

        props?.onSubmit && props?.onSubmit({ data: JSON.stringify(data) });
    }

    return (
        <>
            <CardStyled title={<Translate message={`global.title.translate`} />}>
                {
                    <Prompt
                        when={ formStateDirty }
                        message={ translate('global.unsaved_changes_leave') }
                        beforeUnload={ true }
                    />
                }
                <Form {...layout} ref={formRef} name="control-ref" onFinish={ onFinish } onChange={() => {
                    setFormStateDirty(true);
                }}>
                    <Space direction={`vertical`} style={{ display: "flex" }}>
                        <Tabs className="card-tabs" type={`card`} items={
                            data.translatableLocales.map((locale: string) => {
                                const tabTranslations = data.translations.filter((x: any) => x.locale === locale);
                                const generateTranslationKey = (fieldName: string) => {
                                    return `role.field.${fieldName}`;
                                }

                                return {
                                    label: locale,
                                    key: locale,
                                    forceRender: true,
                                    children:
                                        <Form.List name={locale} initialValue={tabTranslations}>
                                            {(translations) => {
                                                return <Descriptions bordered>
                                                    { translations.map((translation, i) => (
                                                        <Descriptions.Item key={translation.key} span={3} label={
                                                            <Translate message={generateTranslationKey(tabTranslations[translation.name].fieldName)} domain={TranslationDomainEnum.USER_ADMINISTRATION} />
                                                        }>
                                                            <Form.Item {...translation} key={translation.name + i} name={[translation.name, 'defaultValue']} label={<Translate message={`global.field.default_value`} />}>
                                                                <Input disabled={true} />
                                                            </Form.Item>
                                                            <Form.Item {...translation}
                                                               key={translation.name + i + 1}
                                                               name={[translation.name, 'translatedValue']}
                                                               label={<Translate message={`global.field.translated_value`} />}
                                                               rules={[ RequiredConstraint(), MaxLengthConstraint(tabTranslations[translation.name].length) ]}
                                                            >
                                                                <Input />
                                                            </Form.Item>
                                                        </Descriptions.Item>
                                                    ))}
                                                </Descriptions>
                                            }}
                                        </Form.List>
                                }
                            })
                        } />
                    </Space>
                </Form>
            </CardStyled>

            <ButtonBar>
                <Button type="primary" htmlType={`submit`} onClick={() => {
                    formRef.current?.submit()
                }}><Translate message={`global.button.save`} /></Button>

                <Button type="primary" className={`ant-btn-secondary`} onClick={() => {
                    navigate('/role')
                }}><Translate message={`global.button.back_to_list`} /></Button>
            </ButtonBar>
        </>
    )
})